import { DateTime, Duration } from 'luxon';
import { GradePageQuery_turma_horario } from '../../graphql/queries/__generated__/GradePageQuery';

/**
 * Gera horários de 50 minutos a partir de hora_inicio e hora_fim
 * e pula 10 minutos a cada 2 horarios
 * */
const gerar_horarios = (horario: GradePageQuery_turma_horario) => {
  const horarios = [];

  let hora_inicio = DateTime.fromISO(horario.hora_inicio);
  const hora_fim = DateTime.fromISO(horario.hora_fim);

  const diferenca = Duration.fromObject({
    hours: hora_fim.hour - hora_inicio.hour,
    minutes: hora_fim.minute - hora_inicio.minute,
  });

  const qtde_horas = diferenca.hours + diferenca.minutes / 60;
  const qtde_horarios = Math.round(qtde_horas / ((50 * 1) / 60));

  for (let i = 0; i < qtde_horarios; i++) {
    horarios.push({
      hora_inicio: hora_inicio.toFormat('HH:mm'),
      hora_fim: hora_inicio.plus({ minutes: 50 }).toFormat('HH:mm'),
    });

    hora_inicio = hora_inicio.plus({ minutes: 50 });

    if ((i + 1) % 2 === 0) {
      hora_inicio = hora_inicio.plus({ minutes: 10 });
    }
  }

  return horarios;
};

export { gerar_horarios };
